const qBank = [
{
	question:
	"india national bird ?",
	answers: ["pigeon", "peacock", "parrot", "owl"],
	correct: "peacock",
	questionId: "099099"
},
{
	question:
	"india national animal ?",
	answers: ["tiger", "cow", "lion", "mammal"],
	correct: "tiger",
	questionId: "093909"
},
{
	question:
	"india national flower ?",
	answers: ["rose", "lotus", "jasmine", "sunflower"],
	correct: "lotus",
	questionId: "009039"
},
{
	question:
	"india national fruit ?",
	answers: ["mango", "apple", "banana", "orange"],
	correct: "mango",
	questionId: "090089"
},
{
	question:
	"capital of india ?",
	answers: ["delhi", "haryana", "mumbia", "noida"],
	correct: "delhi",
	questionId: "01010101"
},
{
	question:
	"indian national vegetable ?",
	answers: ["tamato", "onion", "patato", "pumpkin"],
	correct: "pumpkin",
	questionId: "092299"
},
{
	question:
	"who is fastest animal in the world ?",
	answers: ["horse", "rabbit", "lion", "cheetah"],
	correct: "cheetah",
	questionId: "099099"
},
{
	question:
	"largest river in india ?",
	answers: ["yamuna", "ganga", "ravi", "sindhu"],
	correct: "ganga",
	questionId: "222099"
},
{
	question:
	"Who is king of the jungle? ?",
	answers: ["lion", "tiger", "elephant", "cow"],
	correct: "lion",
	questionId: "2222099"
},
{
	question:
	"Which animal is known as the 'Ship of the Desert ?",
	answers: ["cow", "dog", "cat", "camel"],
	correct: "camel",
	questionId: "09922099"
},
{
	question:
	"How many days are there in a week ?",
	answers: ["6", "7", "8", "9"],
	correct: "7",
	questionId: "222292099"
},
{
	question:
	"hHow many hours are there in a day ?",
	answers: ["22", "23", "24", "25"],
	correct: "24",
	questionId: "0998999099"
},
{
	question:
	"Rainbow consist of how many colours ?",
	answers: ["4", "5", "6", "7"],
	correct: "7",
	questionId: "099099"
},
{
	question:
	"What is the National Anthem of India ?",
	answers: ["Jana Gana Mana", "Vande Matram", "Hanuman Chalisha", "Jai Wawan"],
	correct: "Jana Gana Mana",
	questionId: "099099"
},
{
	question:
	"Name the National tree of India ?",
	answers: ["neem", "amla", "peepal", "banyan"],
	correct: "banyan",
	questionId: "099099"
},
{
	question:
	"Name the biggest continent in the world ?",
	answers: ["usa", "australia", "asia", "europe"],
	correct: "asia",
	questionId: "09459099"
},
{
	question:
	"How many continents are there in the world ?",
	answers: ["5", "6", "7", "3"],
	correct: "7",
	questionId: "094590975"
},
{
	question:
	"Which is the smallest month of the year ?",
	answers: ["jan", "feb", "dec", "aug"],
	correct: "feb",
	questionId: "091221485"
},
{
	question:
	"Which colour symbolises peace ?",
	answers: ["red", "green", "white", "blue"],
	correct: "white",
	questionId: "091221859"
},

];

// n = 5 to export 5 question
export default (n = 5) =>
Promise.resolve(qBank.sort(() => 0.5 - Math.random()).slice(0, n));
